module.exports = __webpack_public_path__ + "static/media/Lion.2f805262.png";